const frames = {
    'regular': '/favicon.ico',
    'notification': '/favicon_notifcation.ico',
}

export default class FaviconManager
{
    animating = false;
    currentAnimation = "none";
    animationTimeout = null;
    currentFrame = 0;

    animateNotification()
    {
        this.animating = true;
        this.currentAnimation = "notification";
        this.update();
    }

    stopAnimating()
    {
        this.animating = false;
        this.currentAnimation = "";
        let link = document.querySelector("link[rel~='icon']");
        link.href = window.location.origin + frames['regular'];
        this.update();
    }

    update()
    {
        clearTimeout(this.animationTimeout);

        if (this.animating)
        {
            switch (this.currentAnimation)
            {
                case "notification":
                    this.startNotificationAnim();
                    break;
            }
        }
    }

    startNotificationAnim()
    {
        let link = document.querySelector("link[rel~='icon']");

        let animFrames = [ frames["regular"], frames["notification"] ];
        let that = this;

        this.animationTimeout = setInterval(function()
        {

            if (that.currentFrame >= animFrames.length - 1)
            {
                that.currentFrame = 0;
            }
            else
            {
                that.currentFrame++;
            }

            link.href = window.location.origin + animFrames[that.currentFrame];
        }, 1000);
    }
}

